import { IncomeCalculatorDefaultFormFields } from '../../../../@types/shared/income-calculator';
import { sharedIncomeCalculatorDefaultFormFields } from '../config';

export const getSharedIncomeCalculatorDefaultValues = (): IncomeCalculatorDefaultFormFields => {
  return {
    PER: sharedIncomeCalculatorDefaultFormFields.PER.defaultValue,
    INK: sharedIncomeCalculatorDefaultFormFields.INK.defaultValue,
    ORT: sharedIncomeCalculatorDefaultFormFields.ORT.defaultValue,
    JVA: sharedIncomeCalculatorDefaultFormFields.JVA.defaultValue,
    DMK: sharedIncomeCalculatorDefaultFormFields.DMK.defaultValue
  };
};
